import React, { useState } from 'react';
import { Campsite, NormalizedDogWalk } from '../types';
import { postReview } from '../utils/api';

interface ReviewModalProps {
  site: Campsite | NormalizedDogWalk;
  onClose: () => void;
}

const ReviewModal: React.FC<ReviewModalProps> = ({ site, onClose }) => {
  const [text, setText] = useState('');
  const [stars, setStars] = useState(5);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const siteId = 'ID' in site ? site.ID : String(site.id);
  const siteName = 'Name' in site ? site.Name : site.name;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!text.trim()) return;
    setSubmitting(true);
    await postReview(siteId, text, stars);
    setSubmitting(false);
    setSubmitted(true);
  };

  return (
    <div className="review-modal-panel" style={{ padding: '20px' }}>
      {submitted ? (
        <div>
          <h3>🐾 Thank you for your review!</h3>
          <button onClick={onClose}>Close</button>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <h3>Review: {siteName}</h3>

          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
              Rating:
            </label>
            <div style={{ fontSize: '24px' }}>
              {[1, 2, 3, 4, 5].map(star => (
                <span
                  key={star}
                  onClick={() => setStars(star)}
                  style={{
                    cursor: 'pointer',
                    color: star <= stars ? '#ffc107' : '#ddd',
                    marginRight: '5px'
                  }}
                >
                  ★
                </span>
              ))}
              <span style={{ fontSize: '14px', marginLeft: '10px', color: '#666' }}>
                {stars} star{stars !== 1 ? 's' : ''}
              </span>
            </div>
          </div>

          <textarea
            value={text}
            onChange={e => setText(e.target.value)}
            placeholder="Tell us how your pup enjoyed this walk..."
            style={{ width: '100%', minHeight: '100px', marginBottom: '10px' }}
            required
          />
          <button type="submit" disabled={submitting}>
            {submitting ? 'Submitting...' : 'Submit Review'}
          </button>
          <button type="button" onClick={onClose}>Cancel</button>
        </form>
      )}
    </div>
  );
};

export default ReviewModal;